import React, { FC } from "react";
import { SingleFilter } from "./singleFilter";
import { approvalFilters, getFilterProps } from "./helper";
import { IconCheck } from "../../../../utils/icons";

// Approved / not approved (URL key `approved`) — the dashboard's deliverable
// approval cards link here.
interface Props {
  onFilterSelect: (key: string, id?: string) => void;
  queryFilters?: any;
}

export const ApprovalFilter: FC<Props> = ({ onFilterSelect, ...rest }) => (
  <SingleFilter
    {...rest}
    {...getFilterProps(approvalFilters, "approved")}
    title="Approval"
    icon={IconCheck}
    updateSearch={onFilterSelect}
  />
);
